import React from 'react'
import { WidgetProps } from '@rjsf/utils'
import { useDispatch } from 'react-redux'

import { addDialogs } from '../../../../../../../actions/bot'
import { useSelectPortalRef } from '../../../../../../SelectPortalProvider'
import { DialogCreatableSelect } from '../../../../../selects/variants/DialogSelect'

export const DialogCreatableSelectWidget: React.FC<WidgetProps> = ({
  value: dialogId,
  onChange,
  uiSchema
}) => {
  const dispatch = useDispatch()
  const portalRef = useSelectPortalRef()

  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      <DialogCreatableSelect
        id={'root_dialog'}
        selectedDialogId={dialogId}
        menuPortalTarget={portalRef}
        isClearable={uiSchema?.['ui:clearable']}
        onChange={option => {
          const { value: dialogId, __isNew__: isNewDialogId, label: dialogName } = option || {}

          if (dialogId && isNewDialogId) {
            dispatch(addDialogs({ [dialogId]: { id: dialogId, name: dialogName, steps: [] } }))
          }

          // Undefined for all falsy values, because empty string validates as a value,
          // even if required
          onChange(dialogId || undefined)
        }}
      />
    </span>
  )
}
